import {Injectable} from '@angular/core';
import {
    AbstractDataServiceDtoAdapter
} from '../../../../../core/service/v2/dataservice/adapter/abstractDataServiceDto.adapter';
import {MedicalMorphologyModel} from '../../../api/model/medicalMorphology.model';
import {MedicalMorphologyConverter} from '../../../api/model/converter/medicalMorphology.converter';
import {MedicalMorphologyDataService} from './medicalMorphologyData.service';

@Injectable({providedIn: 'root'})
export class MedicalMorphologyDataServiceAdapter extends AbstractDataServiceDtoAdapter<MedicalMorphologyModel, MedicalMorphologyConverter> {
    constructor(dataService: MedicalMorphologyDataService, converter: MedicalMorphologyConverter) {
        super(dataService, converter);
    }
    newStoredEntityInstance(): MedicalMorphologyModel {
        return new MedicalMorphologyModel();
    }
}
